import axios from "axios";

export const getPayRentData = () => {
    return axios.get(`payrent/data`).then((res) => res).catch((error) => error);
}

export const getPayRentDetail = (id) => {
    return axios.get(`payrent/detail/${id}`).then((res) => res).catch((error) => error);
}

export const svUpdataRentDetail = (formData)=>{
    return axios.post('payrent/detail/updata', formData).then( 
        (res) =>  { return { status: true, description: res.data.description }},
        (error) => { return { status: false, description: (!error.response.data)?"Something went wrong.": error.response.data.description } }
      );
}

export const svDeleteDetailsPayment = (id)=>{
    return axios.delete(`payrent/detail/destroy/${id}`)
    .then((res) => res)
    .catch((err) => err);
}